module.exports = __webpack_public_path__ + "img/2.7cf2a2f0.jpg";